/**
 * XUniqueSorted.
 *
 * @param array - array of numbers
 * @returns - sorted array
 */
export function xUniqueSorted(array) {
    return Float64Array.from(new Set(array)).sort();
}
//# sourceMappingURL=xUniqueSorted.js.map